module.exports = __webpack_public_path__ + "img/glassquality_4.c6e0d969.png";